//your environment variables and config go here
const properties = {
  PUBLIC_URL: process.env.BASE_URL || '/',
  aiqBaseUrl: process.env.AIQ_BASE_URL || 'http://localhost:3001',
  environment: process.env.ENVIRONMENT,
  // Okta config
  clientId: process.env.REACT_APP_CLIENT_ID,
  issuer: process.env.REACT_APP_ISSUER,
  oktaSignOutUrl: process.env.OKTA_SIGNOUT_URL,

  //Intercom config
  appId: process.env.INTERCOM_APP_ID,
  intercomSecret: process.env.INTERCOM_SECRET,

  //Fastapi chain
  chainBaseUrl: process.env.FASTAPI_CHAIN,
  standardChain: '/chains/standard_chain',
  createNamespace: '/pinecone/create_namespace',

  // Report download APIs
  downloadReports: '/api/v1/reports/name',
  downloadMultipleReports: '/api/v1/reports/multiple',
  downloadComplianceAssuranceReport: '/api/v1/reports/compliance-assurance',
  downloadComprehensiveReport: '/api/v1/reports/comprehensive-compliance',
  generateReport: '/api/v1/reports/generate-report',
  //Summary page URLs
  summaryBaseUrl: '/api/v1/summary',
  totalPlanPaid: '/total-plan-paid',
  pepm: '/pepm',
  pmpm: '/pmpm',
  pmpmAndPepm: '/pmpmandpepm',
  careQuality: '/careGaps',
  highCostClaimants: '/high-cost-claimants',
  claimantsDistribution: '/claimants-distribution',
  utilizationPer100: '/utilization',
  utilizationByCost: '/utilization-by-cost',
  utilizationByMember: '/utilization-by-member',
  condition: '/condition',
  polyDiseasePrev: '/poly-disease-prev',
  healthDistribution: '/health-distribution',
  prevalenceByGender: '/prev-by-gender',
  prevalenceByAge: '/prev-by-age',
  pharmacyUsageByCost: '/pharmacyusage',
  pharmacyUsageByMember: '/pharmacyusage-by-count',
  chronicPrevalence: '/api/v1/chronic-prevalence',
  chronicPrevalenceByRespiratory:
    '/api/v1/chronic-prevalence/prev-by-respiratory',
  prevalanceByRespiratory: '/api/v1/disease-prevalence/prev-by-respiratory',
  diseasePrevalenceByCost: '/top-diagnosis-by-cost',
  diseasePrevalenceByMember: '/top-diagnosis-by-member',
  topConditionsByCost: '/top-diagnosis-by-cost',
  topConditionsByMember: '/top-diagnosis-by-member',
  topProceduresByMember: '/top-procedure-by-member',
  topProceduresByCost: '/top-procedures-by-cost',
  topMedicationByCost: '/top-medication-by-cost',
  topMedicationByMember: '/top-medication-by-member',
  riskSummary: '/risk-summary',
  riskCost: '/risk-cost',
  riskUtilization: '/risk-utilization',
  riskPrevalence: '/risk-prevalence',
  riskTriggerConditions: '/risk-trigger-conditions',
  riskStratification: '/risk-stratification',
  riskRising: '/risk-rising',
  riskIndex: '/overallRiskIndex',
  costTrend: '/cost-trend',
  latentRisk: '/api/v1/latentRisk',
  members: '/members',
  diseaseSummary: '/disease-summary',
  diagnosedCount: '/diagnosed-count',
  medicalLossRatio: '/medical-loss-ratio',
  employeeDependentSpend: '/employee-dependent-spend',
  employeeDependentPlanPaid: '/employee-dependent-planpaid',
  riskDrugs: '/risk-consumption',

  //Disease Prevalence URLs
  diseasePrevalence: '/api/v1/disease-prevalence',
  prevalenceSummary: '/prevalence-summary',
  pcDistribution: '/pc-distribution',
  memberDistributionByCost: '/member-distribution-by-cost',
  memberDistributionByMember: '/member-distribution-by-member',
  sitesOfCareByMember: '/sites-of-care-by-member',
  sitesOfCareByCost: '/sites-of-care-by-cost',
  hccMemberDistribution: '/member-distribution-by-hcc',
  diseasePrevalnceByMember: '/disease-prev-by-member',
  diseasePrevalnceByCost: '/disease-prev-by-cost',
  topSpecializationByMember: '/specialization-by-member',
  topSpecializationByCost: '/specialization-by-cost',
  getDisPrevalenceCohortMembers: '/disease-prev-cohort-members',

  //Member summary URLs
  memberSummaryBaseUrl: '/api/v1/members-summary',
  careQualityMeasures: '/care-quality-measures',
  diagnosisByCost: '/top-diagnosis-by-cost',
  diagnosisByMember: '/top-diagnosis-by-member',
  proceduresByCost: '/top-procedures-by-cost',
  proceduresByMember: '/top-procedure-by-member',
  membersDetails: '/api/v1/riskpatientlist/',
  membersDetailsSummary: '/api/v1/members/member-details-summary',
  providersByCost: '/top-provider-by-cost',
  providersByMember: '/top-provider-by-member',

  //High cost claimants URLs
  highCostClaimantsBaseUrl: '/api/v1/high-cost-claimants',
  costStratification: '/costStratification',
  medical: '/medical',
  rx: '/rx',
  topHighCostClaimants: '/top-high-cost-claimants',

  // stop-loss page urls:
  stopLossBaseUrl: '/api/v1/stop-loss',
  getDiseaseList: '/disease-list',
  getStopLossDiseaseCohortMembers: '/disease-list-cohort-members',

  // Utilization RX urls:
  utilizationRxBaseUrl: '/api/v1/utilization-summary',
  pharmacyCostTrend: '/pharmacy-cost-trend',
  costBreakDown: '/cost-break-down',
  topDrugs: '/top-drugs',
  rxUtilization: '/rx-utilization',
  utilizationNetwork: '/network-utilization',
  medicalUtilization: '/medical-utilization',
  procedureUtilization: '/procedure-utilization',
  topTherapeutics: '/top-therapeutics',
  drugUtilizationSummary: '/drug-utilization-summary',

  //Network Usage Page URLS:
  networkBaseUrl: '/api/v1/network-leakage',
  amountRatio: '/amount-ratio',
  networkSummary: '/network-summary',
  networkSummaryReport: '/network-summary-report',
  networkUtilization: '/network-utilization',
  outNetworkMembersList: '/out-network-members-list',

  getReportPlan: '/api/v1/specific-deductible/analysis',
  specificDeductible: '/api/v1/specific-deductible/amount',
  getPlanDates: '/api/v1/specific-deductible/plan-dates',

  //performance-plan
  getClaimsStatusRejected: '/api/v1/plan-performance/rejected-claims',
  getRejectedClaimsPercent: '/api/v1/plan-performance/rejected-claims-percent',
  getClaimsStatusPendingDistribution: '/api/v1/plan-performance/pending-claims',
  getBudget: '/api/v1/plan-performance/budget',
  getTotalMedicalCostDistribution:
    '/api/v1/plan-performance/total-medical-cost',
  getClaimsStatusDistribution: '/api/v1/plan-performance/claim-status-dist',
  getCostDistribution: '/api/v1/plan-performance/cost-distribution',

  //members
  membersBaseUrl: '/api/v1/members',
  memberDetails: '/member-details',
  claimDetailsCsv: '/claim-details-csv',
  claimDetailsExcel: '/claim-details-excel',
  claimDetail: '/medical-history-claim',
  patientProfile: '/patient-profile',
  healthDetails: '/health-details',
  individualRafScore: '/individual-raf-score',
  ddiScore: '/ddi-score',
  medicationAdherence: '/medication-adherence',
  chronicConditions: '/chronic-health-conditions',
  inherentConditions: '/inherent-risk-conditions',
  activeMedications: '/active-medications',
  getChronicCohortMembers: '/chronic-prev-cohort-members',

  //enrollmentPage Urls:
  enrollmentPageBaseUrl: '/api/v1/enrollment-metrics',
  femaleToMaleRatio: '/female-male-ratio',
  membersData: '/members',
  geographicData: '/geographic-distribution',
  enrollmentHealthCare: '/healthcare',
  planDistribution: '/plan-distribution',
  enrollmentAnalysis: '/enrollment-analysis',

  //claim-metrics
  claimMetricsUrl: '/api/v1/claims-metrics',
  claimsTopPlanPaid: '/claims-top-plan-paid',
  claimsTopMemberPaid: '/claims-top-member-paid',
  claimsImpact: '/claims-impact',
  paidClaimsTrend: '/paid-claims-trend',

  //user management service
  userManagementBaseUrl: process.env.USER_SVC_BASE_URL,
  users: '/api/v1/users',
  login: '/login',
  loginHistory: '/login-history',
  refreshToken: '/refresh-token',
  getUserByEmail: '/api/v1/users/email/',
  getAllOrganizations: '/api/v1/organizations',
  customReports: '/api/v1/custom-reports',
  customDashboard: '/api/v1/custom-dashboards',
  customQueries: '/api/v1/custom-queries',
  customQueryBuild: '/api/v1/custom-query-build',
  features: '/api/v1/features',
  getAllFeatures: '/all-types',
  multipleDelete: '/multiple-delete',
  delete: '/delete',
  screen: '/api/v1/screens',
  sendEmail: '/send-email',
  customQueryMemberDetails: '/member-details',
  customQueryClaims: '/claim-details',
  customQueryFeatures: '/features',

  careNavigator: '/api/v1/care-navigator',
  getByRole: '/by-role',
  getByEmail: '/email/',

  // risk patient details
  riskPatientList: '/api/v1/riskpatientlist',
  deductiblePatientList: '/api/v1/riskpatientlist/dedictiblePatientList',

  //HomePage employer group url
  employerGroupURL: '/api/v1/employergroups',
  dateFiltersURL: '/api/v1/date-filters',
  getNotifications: '/get-notifications',
  getQuickLinks: '/get-quickLinks',
  updateQuickLinks: '/update-quickLinks',

  //Utilization Provider Page URLS;
  topFacilities: '/top-facility',
  topPhysicians: '/top-physician',

  //Utilizations
  utilizationBaseUrl: '/api/v1/utilization-summary',
  topServiceProviders: '/service-provider-summary',
  inPatientAdmissions: '/inpatient-admits',
  inPatientDays: '/inpatient-days',
  inPatientAvgStay: '/inpatient-avg-stay',
  patientAdmissions: '/patient-admission',
  glpDrug: '/glp-drug',
  glp1DrugsDetails: '/glp-drugs-details',
  glp1DrugsClassification: '/glp-drugs-by-chronic',
  specialityDrugDetails: '/speciality-drugs-details',
  getGLP1DrugCohortMembers: '/glp-drug-cohort-member',

  //savings utilizations
  savingsUtilizationBaseUrl: '/api/v1/savings-utilization',
  savingsUtilizatonSummary: '/summary',
  fillsAndBreakdownCostTrend: '/fills-breakdown-costtrend',
  savingsProgramDetails: '/savings-program-details',

  //care quality
  careQualityBasicUrl: '/api/v1/care-quality',
  distribution: '/distribution',
  summary: '/summary',

  //care quality internal
  careQualityInternalBasicUrl: '/api/v1/care-quality-internal',
  careQualityInternalSummary: '/summary',
  memberDistributionRisk: '/member-distribution-risk',
  memberDistributionAge: '/member-distribution-age',
  memberDistributionGender: '/member-distribution-gender',
  topServiceType: '/top-service-type',
  primaryCareDistribution: '/primary-care-distribution',
  careQualityInternalMemberSummary: '/member-summary',
  careQualityMemberSummaryIds: '/care-quality-member-summary',

  //utilizationProcedure urls
  utilizationSummary: '/api/v1/utilization-summary',
  procedureCostTrend: '/procedures-cost-trend',
  procedureCostSpend: '/procedures-cost-spend',
  procedureCostSpendCSV: '/procedures-cost-spend-csv',
  procedureCostFreQuencyCSV: '/procedures-cost-frequency-csv',
  procedureCostFreQuency: '/procedures-cost-frequency',
  procedureDetails: '/procedures-details',
  procedureDetailsCSV: '/procedures-details-csv',

  //recommendationsScreen Urls
  recommendedScreen: '/api/v1/recommended-screen',
  recommendedDownloadCsv: '/download-csv',
  recommendedDownloadExcel: '/download-excel',

  //Episodes of care Urls
  episodesOfCare: '/api/v1/episodes-of-care',
  treatmentCostBreakdown: '/getTreatmentCostBreakdown',
  episodeTypeSummary: '/getEpisodeTypeSummary',
  episodeMemberData: '/getEpisodeMemberData',
  costBreakDownAPI: '/getCostBreakdown',
  eocOverview: '/getEpisodeSummary',
  eocTable: '/getAllEpisodes',
  qualityMeasures: '/getQualityMeasures',

  //Pharmacy Spend
  pharmacySpend: '/api/v1/pharmacy-spend',
  pharmacySpendMedical: '/medical',
  pharmacySpendRx: '/rx',
  pharmacySummary: '/summary',
  drugSurge: '/drug-surge',
  drugCategories: '/drug-categories',
  top10Utilisations: '/top-10-utilisations',
  getMedPharmaCohortMember: '/medpharma-cohort-member',

  //Cohorts Urls
  cohortBaseUrl: '/api/v1/cohort-analysis',
  cohortSummary: '/summary',
  cohortHighCostClaimants: '/high-cost-claimants',
  cohortMultipleDrug: '/multiple-drug-cohort',
  multipleDrugDetails: '/multiple-drug-details',
  drillDown: '/drill-downs',
  drillDownSearch: '/search',
  searchCohorts: '/search-cohorts',
  searchCohortMembers: '/search-cohort-members',

  //Waste Calculator Urls
  wasteCalculatorBaseUrl: '/api/v1/waste-calculator',
  wastageSummary: '/summary',
  wastageInternalSummary: '/internal-summary',
  wastageCategories: '/wastage-categories',
  wastageSubCategories: '/sub-categories-by-wastage-category',
  wastageTopProviders: '/top-providers-by-wastage-category',
  wastageCategoryMembersList: '/wastage-category-members-list',

  //Specific Deductibles
  specificDeductibles: '/api/v1/get-deductibles',

  //Kpi Tracker
  kpiTrackerBaseUrl: '/api/v1/kpi-tracker',
  getAllPrograms: '/getAllPrograms',
  pepmTrend: '/pepmTrend',
  pmpmTrend: '/pmpmTrend',
  totalCost: '/totalCost',
  prevalenceRate: '/prevalenceRate',
  qualityMeasure: '/qualityMeasure',

  //Onboarding Urls
  onboarding: '/api/v1/onboarding/upload',
  files: '/api/v1/onboarding/list-files',
  fileUploadStatus: '',

  //CONTRACT AIQ
  contractBaseUrl: '/api/v1/contract-aiq',
  masterDocument: '/master-document',
  organisation: '/organisation',
  contractDetails: '/contract-details',
  metadata: '/metadata',
  stoplosssMetadata: '/stoplossMetadata',
  obligations: '/obligations',
  asoObligations: '/aso-obligations',
  feeStructure: '/fee-structure',
  riskReportClauses: '/risk-report-clauses',
  allContracts: '/all-contracts',
  discardOrRestore: '/discard-or-restore',
  readFile: '/read-file',
  getContractDocuments: '/get-documents',
  performances: '/performances',
  tables: '/tables',
  stoplossTable: '/stoplossTableData',
  stoplossReports: '/stoplossReports',
  gagClauseReport: '/gag-clause',
  regulatoryComplianceReport: '/regulatory-compliance',
  purchasingStandardsReport: '/purchasing-standards',
  compensationTransparencyReport: '/compensation-transparency',
  interContractReport: '/inter-contract',
  getSummaryOfFindings: '/get-summary-of-findings',
  saveSummaryOfFindings: '/save-summary-of-findings',
  getSummaryOfFindingsParams: '/get-summary-of-findings-params',

  //Compliance Assurance URLs
  getGroupById: '/get-group-by-id',
  deleteGroup: '/delete-group',
  updateGroup: '/update-group',
  addGroup: '/add-new-group',
  getAllGroups: '/get-all-groups',
  getServiceAgreements: '/get-service-agreement',
  getHealthcarePartner: '/get-health-care-partner',
  addHealthcarePartner: '/add-health-care-partner',
  uploadContracts: '/upload-contracts',
  addContract: '/add-contract',
  updateContract: '/update-contract',
  getContracts: '/get-contracts',
  addReports: '/add-reports',
  uploadDocConversion: '/upload-doc-conversion',
  uploadPlanDocs: '/upload-plan-documents',
  addPlanDocs: '/add-spd-plans',
  getPlanDocs: '/get-plan-documents',
  planTypes: '/plan-types',
  getContractDetails: '/get-contract-details',
  deleteContract: '/delete-contract',
  uploadMasterDoc: '/upload-master-doc',
  updateDocConversion: '/update-doc-conversion',
  deletePlan: '/delete-plan',
  updatePlan: '/update-plan',
  deletePlanDocument: '/delete-plan-doc',
  getMatrixByProvisions: '/provisions-by-section',
  getAllContractsAndDrafts: '/get-all-contracts-and-drafts',

  //Draft Agreements
  draftBaseUrl: '/api/v1/drafts',
  createDraft: '/create-draft',
  getAllDraftNames: '/draft-names',
  getAllDrafts: '/all-drafts',
  deleteDraft: '/delete-draft',
  draftById: '/get-draft-by-id',

  //Metadata
  extractMetadata: '/extract-metadata',
  chainDoc: '/chain-doc',
  addStoplossMetadata: '/add-stoploss-metadata',
  getStoplossMetadata: '/stoploss-metadata',
  addAdministrativeMetadata: '/add-administrative-services-metadata',
  getAdministrativeMetadata: '/administrative-services-metadata',
  getContractReports: '/contract-reports',
  landingAiExtract: '/landing-ai-extract',
  extractInterContract: '/extract-inter-contract',

  //Merge Document
  convertToDoc: '/convert-to-doc',
  getDocUrl: '/doc-url',
  getDocVersions: '/doc-versions',
  mergeDoc: '/merge-doc',
  exportPdf: '/export-to-pdf',
  downloadFiles: '/download-files',

  //Data Extraction URLs
  extractContract: '/chains/metadata_evidence_chain',

  //Playbook URLs
  playbookBaseUrl: '/api/v1/playbook',
  masterPlaybooks: '/master',
  acceptPlaybook: '/accept-playbook',
  riskReport: '/risk-report',
  riskReportClausesPlaybook: '/risk-report-clauses',
  addQuestion: '/add-question',
  changeCategory: '/change-category',
  ignoreClause: '/ignore-clause',
  gagClauseInfo: '/gag-clause-info',
  compensationTransparencyInfo: '/compensation-transparency-info',

  //Stop Loss Aggregate API urls
  stoplossAggregateBaseUrl: '/api/v1/stoploss-aggregate',
  stoplossAggregateSummary: '/summary',
  stoplossPaidClaims: '/paid-claims-cost-trend',
  stoplossAggregateReport: '/aggregate-report',

  //Summary Of Benefits Apis
  sobBaseUrl: '/api/v1/sob',
  getDocuments: '/getSpdDocuments',
  getSpdReports: '/getSpdReports',

  quarterlyReport: '/api/v1/reports/quarterly-report',

  //Quarterly APIs
  quarterlyBaseUrl: '/api/v1/quarterly-report',
  topChronicByCost: '/top-diagnosis-by-spend',
  topMedpharmaDrugs: '/top-medpharma-drugs',
  topServicesInMedicalSpend: '/top-services',
  medicalTopPlanPaid: '/medical-top-plan-paid',
  rxTopPlanPaid: '/rx-top-plan-paid',
  overallSummary: '/overall-summary',
  careNavaigationData: '/care-navigation-data',
  careNavigationMoi: '/care-navigation-moi',

  //Members list
  membersList: '/api/v1/member-list',
  membersListCohort: '/api/v1/member-list/cohort',

  //Data Catalogue
  dataCatalogueBaseURL: '/api/v1/data-catalogue',
  dataCatalogueDetails: '/details',
  updateSavingsProgram: '/update-savings-program',
  addComments: '/add-comments',
  saveAggregateReport: '/save-aggregate-report',
  saveStoplossData: '/save-stoploss-data',
  getOrganizationInfo: '/get-organization-info',
  updateGeneralOrganizationInfo: '/update-general-organization-info',
  updateEmployeeHealthPlan: '/update-employee-health-plan',
  updateKeyVendorPartners: '/update-key-vendors-partners',
  updatePointSolution: '/update-point-solution',
  getSICCodes: '/get-sic-codes',
  getCheckRegisterInfo: '/get-checkregister-info',
  addCheckRegisterDetails: '/add-checkregister-details',

  //Care Navigation
  groupsBaseURL: '/api/v1/groups',
  getGroups: '/get-groups',
  getGroupNames: '/get-group-names',
  createGroup: '/create-group',
  getGroupSummary: '/summary',
  getCareNavigators: '/get-care-navigators',
  getCareNavigatorGroups: '/get-care-navigator-groups',
  deleteCareNavGroup: '/delete-group',
  addCareNavigatorToGroups: '/add-care-navigator-to-groups',

  casesBaseUrl: '/api/v1/cases',
  getCases: '/get-cases',
  acceptCase: '/accept-case',
  assignCase: '/assign-case',
  createCase: '/create-case',
  caseById: '/get-case-by-id',
  updateCaseHealthState: '/update-current-health-state',
  updatePriority: '/update-priority',
  deleteCase: '/delete-case',
  userUsage: '/user-usage',

  patientsBaseUrl: '/api/v1/patients',
  getPatients: '/get-patients',
  createPatient: '/create-patient',
  patientCases: '/get-patient-cases',
  updateCategory: '/update-category',
  getPatientByMemberId: '/get-patient-by-member-id',
  updateContact: '/update-contact',

  caseSurveyBaseUrl: '/api/v1/case-surveys',
  getCaseSurveys: '/get-case-surveys',
  getEngagementReport: '/get-engagement-report',
  createCaseSurvey: '/create-case-survey',
  updateCaseSurvey: '/update-case-survey',

  dynamicFieldsBaseUrl: '/api/v1/dynamic-fields',
  getDynamicFields: '/get-dynamic-field',
  addDynamicFields: '/add-dynamic-fields',

  interactionBaseURL: '/api/v1/interactions',
  getInteraction: '/get-interactions',
  addInteraction: '/create-interaction',
  updateInteraction: '/update-interaction',

  careNavigatorBaseURL: '/api/v1/care-navigator',
  getCareNavigatorProfile: '/get-care-navigator',

  //Ticket Management
  tickets: '/api/v1/tickets',
  createTicket: '/createTicket',
  getAllTickets: '/getAllTickets',
  updateTicket: '/updateTicket',
  comments: '/api/v1/comments',
  addComment: '/addComment',
  getCommentsByTicketId: '/getCommentsByTicketId',
  attachments: '/api/v1/attachments',
  addDetails: '/addDetails',
  uploadAttachment: '/api/v1/onboarding/upload-attachment',
  getAttachmentsByTicketId: '/getAttachmentsByTicketId',
  deleteAttachment: '/deleteAttachment',
  uniqueValues: '/uniqueValues',

  //Risk Register
  riskRegisterBaseUrl: '/api/v1/risk-register',
  addRisk: '/add-risk',
  getRisk: '/get-risks',
  getRiskByQuarter: '/get-risks-by-quarter',
  getAcceptanceReason: '/get-acceptance-reasons',
  getDelayReason: '/get-delay-reasons',
  updateRisk: '/update-risk',
  getCommentsByRiskId: '/get-comments',
  getAttachmentsByRiskId: '/get-attachments',
  uploadRiskAttachment: '/upload-attachment',
  getActivities: '/get-activities',
  addActivity: '/add-activity',
  deleteActivity: '/delete-activity',
  getActivitiesByQuater: '/get-activities-by-quarter',

  uploadTermsAndCondtions: '/api/v1/onboarding/upload-terms-conditions',
  getHasUserAccepted: '/get-has-accepted',
  acceptLatest: '/accept-latest',

  getClaimIds: '/claim-ids',
  getMemberIds: '/member-ids',

  //Due Diligence
  getDueDiligenceDetails: '/get-due-diligence',
  addDueDiligenceDetails: '/add-due-diligence',
  updateDueDiligenceDetails: '/update-due-diligence',
  getDueDiligenceForGroup: '/get-due-diligence-group',
  getDueDiligenceStaticDetails: '/get-due-diligence-static',

  // New Comparison
  createDocComparison: '/create-doc-comparison',
  getMatrixData: '/matrix',
  getAllComparison: '/get-all-comparison',
  getDefaultParameters: '/get-default-parameters',
  getDocComparison: '/get-doc-comparison',
  regenerateDocComparison: '/regenerate-doc-comparison',

  //Term Compiler Screen
  getAllCompilations: '/get-term-compilers',
  getUseCases: '/get-use-cases',
  addNewCompiler: '/new-term-compiler',
  updateCompiler: '/update-term-compiler',
  getTopicsAndTerms: '/get-topics-terms',
  extractTermCompilerMetadata: '/extract-termcompiler-metadata',
  getTermCompilerMetaData: '/get-termcompiler-data',
  addUseCaseAndTopics: '/add-usecase-topics',
  // Experience Screen
  insightsNotification: '/get-insight-notifications',
  updateNotificationView: '/update-notification-view',
  getOrganizationDetails: '/get-organization-info',
  updateOrganisationDetails: '/update-organisation-details',

  //Financial Forensics
  financialForensicsBaseURL: '/api/v1/financial-forensics',
  updateEmployeeCount: '/update-employee-count',
  addVendor: '/add-vendor',
  updateVendor: '/update-vendor',
  deleteVendor: '/delete-vendor',
  updateFeeCalculationVendor: '/update-fee-calulation-vendor',
  addClaims: '/add-claims',
  deleteClaims: '/delete-claims',
  updateClaims: '/update-claims',
  addRebates: '/add-rebates',
  updateRebates: '/update-rebates',
  deleteRebates: '/delete-rebates',
  addScenarios: '/add-scenarios',
  getScenarios: '/get-scenarios',
  duplicateScenario: '/duplicate-scenario',
  getBuildScenario: '/get-build-scenario',
  addBuildScenario: '/add-build-scenario',
  getAvailableDates: '/get-available-dates',
  addNewPlanDates: '/add-plan-dates',
  addReconciliation: '/add-reconciliations',
  getReconciliations: '/get-reconciliations',
  addBuildReconciliation: '/add-build-reconciliation',
  getAddReconciliation: '/get-add-reconciliation',
  updateAddReconciliation: '/update-add-reconciliation',
  updateEmployeeCountAddReconciliation:
    '/update-employee-count-add-reconciliation',
  uploadReconciliationFiles: '/upload-reconciliation-files',
  uploadFiscalControlFiles: '/upload-fiscal-control-files',
  deleteFiscalControlFiles: '/delete-fiscal-control-file',

  addStopLossVendor: '/add-stoploss-vendor',
  updateStopLossVendor: '/update-stoploss-vendor',
  updateFeeCalculationStoploss: '/update-fee-calulation-stoploss',

  // Experience Screen claims
  getCohortAnalysis: '/get-cohort-insights',
  getDefaultClaimsKpi: '/get-default-claims-kpi',
  updateDefaultClaimsKpis: '/update-default-claims-kpi',
  getCustomiseTabs: '/get-customise-tabs',
  updateCustomiseTabs: '/update-customise-tabs',

  //Deep Dive, Trend Analysis, Cohort Comparison Screen
  deepDiveBaseUrl: '/api/v1/deep-dive',
  filterData: '/filterData',
  deepDiveCostTrend: '/cost-trend',
  categoryData: '/category-data',
  trendMetricOptions: '/trend-metric-options',
  createOrUpdateCohortComparison: '/create-update-cohort-comparison',
  getCohortComparisons: '/get-cohort-comparisons',
  getComparisonById: '/get-comparison-by-id',
  getDeepDiveFilteredMembers: '/deep-dive-filterData-members',
  deleteCohortComparison: '/delete-cohort-comparison',
  getAllTrends: '/get-all-trends',
  createOrUpdateTrend: '/create-update-trend',
  getTrendById: '/get-trend-by-id',
  deleteTrend: '/delete-trend',

  // Annual Renewal Process
  renewals: '/api/v1/renewals',
  addNewRenewal: '/add-renewal',
  getNewRenewal: '/get-renewals',
  getRenewalById: '/get-renewal-by-id',
  checkoffLists: '/checkoff-lists',
  updateCheckoffLists: '/update-checkoff-list',
  deleteCheckoffLists: '/delete-checkoff-list',
  getRenewalToolsByEgnid: '/get-renewal-tools-by-egnid',
  updateRenewalTools: '/update-renewal-tools',
  addNotes: '/add-notes-checkoff-list',
  editNotes: '/edit-notes-checkoff-list',
  deleteNotes: '/delete-notes-checkoff-list',

  // Playbook And Standard
  playbookAndStandard: '/api/v1/playbook-and-standard',
  updateMatrixChanges: '/update-matrix-changes',
  getAppliedProvision: '/get-applied-provisions',
  getLatestProvisionUpdatedDate: '/get-latest-provision-updated-date',
  getFiduciaryList: '/get-fiduciary-list',
  getAllPlaybooks: '/get-all-playbooks',
  //Payment Integrity APIs
  paymentIntegrityBaseURL: '/api/v1/payment-integrity',
  getPaymentIntegritySummary: '/get-summary',
  getCategories: '/get-categories',
  getCategoryDetails: '/get-categories-details',

  //Benchmark APIs
  benchmarkBaseURL: '/api/v1/cms-benchmark',
  getBenchmarkSummary: '/get-summary',
  getBenchmarkDetailsSummary: '/get-categories-details-summary',

  otpBaseURL: '/api/v1/otp',
  verifyOTP: '/verify',
  resendOTP: '/resend',

  // Promptchai Apis
  getAiSummary: '/get-ai-summary',

  websocketURL: process.env.WEBSOCKET_URL || 'ws://localhost:3001',

  getCohortMembersCount: '/cohort-members',
  getClaimCohortMembersCount: '/claim-cohort-members',
  getUtilizationAdmissionMemberCount: '/cohort-members-utilization-admission',
  getCohortMemberCountForMedpharma: '/cohort-count-medpharma',
  getCohortMemberCountForOtherDrugs: '/cohort-count-otherdrugs',

  //Contracts V2 endpoints
  contractV2BaseUrl: '/api/v2/contract-aiq',
  reviewState: '/contracts-review-state',
  retryFailed: '/retry-failed',
  regenerateMetadata: '/regenerate-metadata',
  regenerateReport: '/regenerate-report',
};

export default properties;
